/**
 *
 *  Organizations/Show/Campaigns
 *
 */

import React, { useState } from 'react'

// NPM Libraries
import PropTypes from 'prop-types'
// import styled from '@emotion/styled'

// GraphQL
import useQuery from 'components/UseQuery'
import { gql } from '@apollo/client'

// Components
import CampaignsTable from 'components/Organizations/Show/Campaigns/Table'
import DateRangeDropdown from 'components/DateRange/Dropdown'
import { addDays, subDays } from 'date-fns'

const GET_ORGANIZATION = gql`
	query organization($id: ID, $start_date: ISO8601DateTime, $end_date: ISO8601DateTime) {
		org: organization(id: $id) {
			campaigns: campaigns_for_time_period(start_date: $start_date, end_date: $end_date) {
				id
				name
				job_codes
				headline
				user {
					id
					full_name
				}
				objective
				topic_name
				total_registrations_count
				updated_at
				events {
					id
					campaign_id
					venue
					start_time
					capacity
					registrations_count
					attended_count
					confirmation_confirmed_count
					user {
						id
						full_name
					}
					campaign {
						id
						topic_name
					}
				}
				appointments: appointments_not_canceled {
					id
					start_time
					user {
						id
						full_name
					}
					attendee_record {
						contact {
							id
							full_name
						}
						confirmation_status
					}
					campaign {
						id
						topic_name
					}
				}
			}
		}
	}
`

function Campaigns({ organization_id }) {
	const [start_date, setStart] = useState(subDays(new Date(), 6))
	const [end_date, setEnd] = useState(addDays(new Date(), 6))

	const {
		data: { org },
		loading,
	} = useQuery(GET_ORGANIZATION, {
		variables: { id: organization_id, start_date, end_date },
		channels: [organization_id],
		default_data: {
			org: {
				campaigns: [],
			},
		},
		skip: !organization_id,
	})

	return (
		<div>
			<DateRangeDropdown
				start_date={start_date}
				end_date={end_date}
				setStartDate={setStart}
				setEndDate={setEnd}
				disabled={loading}
			/>

			<CampaignsTable campaigns={org.campaigns} noDataText="No campaigns found for date range" />
		</div>
	)
}

Campaigns.propTypes = {
	organization_id: PropTypes.string,
}

export default Campaigns
